import { atom } from 'recoil';
export const manageModulesState = atom({
    key: 'manageModules',
    default: {
        isLoading: false,
        modules: [],
        modalOpen: false,
        totalModules: 0,
        count: 0,
        page: 0,
        pageCount: 0,
        total: 0
    }
});
export const addNewModule = atom({
    key: 'addNewModule',
    default: {
        isLoading: false,
        isFormInvalid: null,
        name: '',
        nameError: '',
        summary: '',
        summaryError: '',
        grades: [],
        gradesError: '',
        count: 0,
        page: 0,
        pageCount: 0,
        total: 0,
        lessons: []
    }
});
